// extracted by mini-css-extract-plugin
export default {"institutionLogo":"InstitutionLogo_institutionLogo__FUNLo","institutionLogoPlaceholder":"InstitutionLogo_institutionLogoPlaceholder__qqDJ3"};